import { createContext } from "react";

export const UserTheme = createContext({});
